import { memo } from "react";
import ArrowDownSorting from "components/svg/ArrowDownSorting";
import classnames from "classnames";
import { ColumnDef } from "types/common/Header";
import { ORDER_BY } from "pages/admin-app/adminapp.constants";

interface Props<T> {
  header: ColumnDef<T>;
  sortedKey: string;
  sortedOrder: ORDER_BY;
  onSort: (sortKey: string) => void;
}

const HeaderCell = <T,>({
  header,
  sortedKey,
  sortedOrder,
  onSort,
}: Props<T>) => {
  const isActiveAsc =
    sortedKey === header.sortKey && sortedOrder === ORDER_BY.ASC;
  const isActiveDesc =
    sortedKey === header.sortKey && sortedOrder === ORDER_BY.DESC;

  const insetClass = classnames("table__header-inset", {
    "table__header-inset--button": header.sortable,
    "table__header-inset--align-right": header.alignRight,
  });

  if (header.sortable) {
    return (
      <th>
        <button
          className={insetClass}
          onClick={() => onSort(header.sortKey)}
          aria-label={`Sort by ${header.displayName}`}
        >
          {header.displayName}
          <div className="table__header-sort-actions">
            <ArrowDownSorting
              className={classnames("table__header-sort svg--180", {
                "table__header-sort--is-active": isActiveAsc,
              })}
            />
            <ArrowDownSorting
              className={classnames("table__header-sort", {
                "table__header-sort--is-active": isActiveDesc,
              })}
            />
          </div>
        </button>
      </th>
    );
  }

  return (
    <th>
      <div className={insetClass}>{header.displayName}</div>
    </th>
  );
};

export default memo(HeaderCell) as typeof HeaderCell;
